import { render, staticRenderFns } from "./CargarDocumentosDeSeleccion.vue?vue&type=template&id=489bab7b&scoped=true"
import script from "./CargarDocumentosDeSeleccion.vue?vue&type=script&lang=js"
export * from "./CargarDocumentosDeSeleccion.vue?vue&type=script&lang=js"
import style0 from "./CargarDocumentosDeSeleccion.vue?vue&type=style&index=0&id=489bab7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489bab7b",
  null
  
)

export default component.exports